export type Movement = {
  name: string;
  description: string;
  intensity: "low" | "medium" | "high";
  category: "stretch" | "strength" | "walk" | "mobility";
};

const DEFAULT_STRENGTH_MOVEMENTS: Movement[] = [
  {
	name: "Push ups",
	description: "Perform 15 strict push ups",
	intensity: "medium",
	category: "strength",
  },
  {
	name: "Bodyweight squats",
	description: "Do 20 bodyweight squats",
	intensity: "medium",
	category: "strength",
  },
  {
	name: "Wall sit",
	description: "Hold a wall sit for 45 seconds",
	intensity: "medium",
	category: "strength",
  },
  {
	name: "Calf raises",
	description: "Do 20 calf raises",
	intensity: "low",
	category: "strength",
  },
  {
	name: "Lunges",
	description: "Do 10 lunges each leg",
	intensity: "medium",
	category: "strength",
  },
];

const DEFAULT_WALK_MOVEMENTS: Movement[] = [
  {
    name: "Walk laps of the house",
    description: "Get up and walk the length of the house 3 times",
    intensity: "low",
    category: "walk",
  },
  {
    name: "Water refill",
    description: "Walk to the kitchen and refill your water bottle",
    intensity: "low",
    category: "walk",
  },
  {
    name: "Step outside",
    description: "Step outside for 2 minutes of fresh air",
    intensity: "low",
    category: "walk",
  },
  {
    name: "Stairs",
    description: "Go up and down the stairs 3 times",
    intensity: "medium",
    category: "walk",
  },
];

const DEFAULT_STRETCH_MOVEMENTS: Movement[] = [
  {
    name: "Hip flexor stretch",
    description: "Hold a hip flexor stretch for 30 seconds each side",
    intensity: "low",
    category: "stretch",
  },
  {
    name: "Hamstring stretch",
    description: "Hold a standing hamstring stretch for 30 seconds each side",
    intensity: "low",
    category: "stretch",
  },
  {
    name: "Chest doorway stretch",
    description: "Hold a doorway chest stretch for 30 seconds",
    intensity: "low",
    category: "stretch",
  },
  {
    name: "Quad stretch",
    description: "Hold a standing quad stretch for 30 seconds each side",
    intensity: "low",
    category: "stretch",
  },
];

const DEFAULT_MOBILITY_MOVEMENTS: Movement[] = [
  {
    name: "Shoulder rolls",
    description: "Do 15 shoulder rolls forward and 15 backward",
    intensity: "low",
    category: "mobility",
  },
  {
    name: "Neck rolls",
    description: "Do 10 slow neck circles in each direction",
    intensity: "low",
    category: "mobility",
  },
  {
    name: "Wrist circles",
    description: "Do 20 wrist circles each direction, flex and extend",
    intensity: "low",
    category: "mobility",
  },
  {
    name: "Thoracic rotation",
    description: "Do 10 seated thoracic rotations each side",
    intensity: "low",
    category: "mobility",
  },
  {
    name: "Cat-cow",
    description: "Do 10 slow cat-cow stretches on the floor",
    intensity: "low",
    category: "mobility",
  },
];

export const DEFAULT_MOVEMENTS: Movement[] = [
  ...DEFAULT_STRENGTH_MOVEMENTS,
  ...DEFAULT_WALK_MOVEMENTS,
  ...DEFAULT_STRETCH_MOVEMENTS,
  ...DEFAULT_MOBILITY_MOVEMENTS,
];

export function getNextMovement(movements: Movement[], lastMovement?: Movement): Movement {

  let filteredMovements = movements;
  if (lastMovement) {
	filteredMovements = filteredMovements.filter((m) => m.name !== lastMovement.name);
  }

  if (filteredMovements.length === 0) {
	filteredMovements = movements;
  }

  const randIndex = Math.floor(Math.random() * filteredMovements.length);
  return filteredMovements[randIndex]!;
}
